module.exports = "/_next/static/images/PowerPersonalization@2x-1e588c1f1682799e4bbb4394e900cc62.webp";